import React from 'react';

const DesktopIcon = ({ icon, label, onClick, style, ...props }) => {
  return (
    <div className="desktop-icon" onClick={onClick} style={style} {...props}>
      <img src={icon} alt={label} />
      <p>{label}</p>
    </div>
  );
};

export default DesktopIcon;
